import React, { useState } from 'react';
import { CommandCentreView } from './CommandCentreView';
import { CompanyOverview } from './CompanyOverview';
import { GateReviewScreen } from './GateReviewScreen';
import { usePortalStore } from '../../store';

const TABS = [
  { id: 'command', label: 'Command' },
  { id: 'overview', label: 'Overview' },
  { id: 'gates',   label: 'Gates' },
] as const;

type DashTab = typeof TABS[number]['id'];

export const DashboardView: React.FC = () => {
  const [active, setActive] = useState<DashTab>('command');
  const { gates } = usePortalStore();
  const pendingGates = gates.filter(g => g.status === 'pending').length;

  return (
    <div className="flex flex-col h-full min-h-0">
      {/* Tab bar */}
      <div
        className="flex-shrink-0 flex gap-1 px-1 pt-1 pb-0"
        style={{ borderBottom: '1px solid var(--border-subtle)' }}
      >
        {TABS.map(tab => {
          const isActive = active === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActive(tab.id)}
              className="relative px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-none"
              style={{
                fontFamily: 'var(--font-ui)',
                color: isActive ? 'var(--accent-amber)' : 'var(--text-secondary)',
                borderBottom: isActive ? '2px solid var(--accent-amber)' : '2px solid transparent',
                backgroundColor: 'transparent',
                marginBottom: '-1px',
              }}
            >
              {tab.label}
              {tab.id === 'gates' && pendingGates > 0 && (
                <span className="badge-count ml-2">{pendingGates}</span>
              )}
            </button>
          );
        })}
      </div>

      {/* Tab content */}
      <div className="flex-1 overflow-auto min-h-0">
        {active === 'command'  && <CommandCentreView />}
        {active === 'overview' && <CompanyOverview />}
        {active === 'gates'    && <GateReviewScreen />}
      </div>
    </div>
  );
};
